import React, {
  forwardRef,
  ForwardedRef
} from "react";
import classNames from "classnames";
import {ButtonCustomType} from "./types";

export const SVVButtonCancel = forwardRef<(HTMLButtonElement | HTMLAnchorElement), ButtonCustomType>(
  function ButtonInternal(
    props: ButtonCustomType,
    ref: ForwardedRef<HTMLButtonElement | HTMLAnchorElement>
  ) {
    const {
      children,
      className,
      // Fjern buttonType fra restProps for å unngå å rendre denne i DOM-en
      // når vi spreader rest til <Element>
      // eslint-disable-next-line
      asElement = "a",
      // eslint-disable-next-line
      hrefAttribute = "href",
      // eslint-disable-next-line
      small,
      // eslint-disable-next-line
      looksLikeLink,
      // eslint-disable-next-line
      iconPlacement,
      // eslint-disable-next-line
      color,
      ...restProps
    } = props;

    const Element = asElement;

    return (
      <div className="cancel-button-container">
        <Element
          {...(hrefAttribute && props.href && {[hrefAttribute]: props.href})}
          {...restProps}
          ref={ref}
          className={classNames("svv-button--looks-like-link", className)}
        >
          {children}
        </Element>
      </div>
    );
  }
);

SVVButtonCancel.displayName = "SVVButtonCancel";
